<template>
  <div
    class="wf-relative wf-h-full"
    :class="editorClasses"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <EditorOptions
      parent="section"
      v-show="hover && ! childHover && ! previewMode"
      :options="menuOptions"
      :parentModule="parentModule"
    />
    <div :class="elementClasses" class="wf-h-full" :style="elementStyles">
      <draggable
        v-model="rows"
        group="componentrows"
        handle=".component-row-handle"
      >
        <EditorComponentRow
          :parentModule="parentModule"
          @mouseover="childHover = true"
          @mouseleave="childHover = false"
          v-for="row in rows"
          :key="row.id"
        />
      </draggable>
    </div>
  </div>
</template>

<script>
  import { ConstantsParser } from '../ConstantsParser'
  import EditorComponentRow from './EditorComponentRow'
  import EditorElement from '../contracts/EditorElement'
  export default EditorElement.extend({
    props: {
      parentModule: {
        type: String,
        required: false
      }
    },
    components: {EditorComponentRow},
    computed: {
      elementClasses() {
        if (this.previewMode) {
          return [...this.constantClasses, ...this.customClasses, ...(new ConstantsParser(this.classes, this.device)).parse()]
        }
        let displayClasses = []
        let classes = Object.keys(this.classes).reduce((carry, device) => {
          let deviceDisplayClass = this.classes[device].find(deviceClass => deviceClass.property == 'Display')
          if (deviceDisplayClass) {
            let opacity = 'wf-opacity-100'
            let prefix = ''
            if (device === 'tablet') {
              prefix = 'sm:'
            }
            if (device === 'desktop') {
              prefix = 'lg:'
            }
            if (deviceDisplayClass.value == 'NONE') {
              opacity = 'wf-opacity-50'
            }
            displayClasses.push(`${prefix}${opacity}`)
          }
          let deviceObject = {}
          let deviceClasses = this.classes[device].filter(deviceClass => deviceClass.property != 'Display')
          this.$set(deviceObject, device, deviceClasses)
          return {...carry, ...deviceObject}
        }, {})
        return [...this.constantClasses, ...this.customClasses, ...(new ConstantsParser(classes, this.device)).parse(), ...displayClasses]
      },
      customClasses() {
        return this.$store.getters[`${this.module}/classes`](this.element, 'customClasses', this.parentModule)
      },
      properties() {
        return this.$store.getters[`${this.module}/properties`](this.element, this.parentModule)
      },
      classes() {
        return this.$store.getters[`${this.module}/classes`](this.element, 'classes', this.parentModule)
      },
      styles() {
        return this.$store.getters[`${this.module}/styles`](this.element, 'styles', this.parentModule)
      },
      menuOptions() {
        return [
          {
            name: 'add-row',
            icon: 'fa-grip-lines',
            method: 'addRow',
            classes: [],
            hoverable: false,
            menu: null,
          },
          {
            name: 'settings',
            icon: 'fa-cog',
            hoverable: true,
            method: 'openMenu',
            classes: [],
            menu: 'component-section-menu',
          }
        ]
      },
      module() {
        return 'componentSectionModule'
      },
      family() {
        return 'sections'
      },
      parent() {
        return this.$parent
      },
      sectionIndex() {
        return this.parent.sectionIndex
      },
      rowIndex() {
        return this.parent.rowIndex
      },
      columnIndex() {
        return this.parent.columnIndex
      },
      pageComponentIndex() {
        return this.parent.pageComponentIndex
      },
      componentIndex() {
        return this.parent.componentIndex
      },
      componentSectionIndex() {
        let element = {
          section: this.sectionIndex,
          row: this.rowIndex,
          column: this.columnIndex,
          component: this.componentIndex,
        }
        if (this.parent.pageComponentIndex !== null && this.parent.pageComponentIndex !== undefined) {
          element = {
            pageComponent: this.pageComponentIndex
          }
        }
        if (this.parentModule == 'layoutPageComponentModule') {
          element = {
            layoutPageComponent: this.pageComponentIndex
          }
        }
        return this.$store.getters[`${this.module}/index`](element, this.id, this.parentModule)
      },
      rows: {
        get() {
          return this.$store.getters['componentRowModule/elements'](this.element, this.parentModule)
        },
        set(value) {
          this.$store.dispatch('componentRowModule/updateOrder', {...this.element, value, parentModule: this.parentModule})
        }
      }
    },
  })
</script>